(() => {
  if(window.__bwAnnouncementInitialized)return;
  window.__bwAnnouncementInitialized=true;
  const instances = new Map();
  function init(bar) {
    if(instances.has(bar)) return;
    const controller=new AbortController(), signal=controller.signal;
    const slides=[...bar.querySelectorAll('.oa-slide')], reduce=matchMedia('(prefers-reduced-motion: reduce)');
    let index=0,timer,exitTimer,paused=false;
    const show=n=>{const old=slides[index];slides.forEach(s=>s.classList.remove('is-exiting'));if(n!==index){old?.classList.remove('is-active');old?.classList.add('is-exiting');}index=n;slides.forEach((s,i)=>s.setAttribute('aria-hidden',String(i!==index)));slides[index]?.classList.add('is-active');clearTimeout(exitTimer);exitTimer=setTimeout(()=>slides.forEach(s=>s.classList.remove('is-exiting')),410);};
    const schedule=()=>{clearTimeout(timer);if(!reduce.matches&&!paused&&slides.length>1)timer=setTimeout(()=>{show((index+1)%slides.length);schedule();},Number(slides[index].dataset.duration)||8000);};
    const motion=()=>{clearTimeout(timer);if(reduce.matches)show(0);else schedule();};
    bar.addEventListener('mouseenter',()=>{paused=true;clearTimeout(timer);},{signal});
    bar.addEventListener('mouseleave',()=>{paused=bar.contains(document.activeElement);schedule();},{signal});
    bar.addEventListener('focusin',()=>{paused=true;clearTimeout(timer);},{signal});
    bar.addEventListener('focusout',()=>{paused=bar.matches(':hover');schedule();},{signal});
    reduce.addEventListener('change',motion,{signal});show(0);motion();
    instances.set(bar,()=>{clearTimeout(timer);clearTimeout(exitTimer);controller.abort();});
  }
  const mount=()=>document.querySelectorAll('.optibio-announce').forEach(init);
  mount();document.addEventListener('shopify:section:load',mount);
  document.addEventListener('shopify:section:unload',e=>{for(const [bar,dispose] of instances)if(e.target.contains(bar)){dispose();instances.delete(bar);}});
})();
